// routes.ts
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    },
    {
        path: '/my',
        name: 'My',
        component: () => import(/* webpackChunkName: "my" */ '@/views/My.vue'),
    },
    {
        path: '/work',
        name: 'Work',
        component: () => import(/* webpackChunkName: "work" */ '@/views/Work.vue'),
    },
    {
        path: '/detailed',
        name: 'Detailed',
        component: () => import(/* webpackChunkName: "detailed" */ '@/views/Detailed.vue'),
    },
    {
        path: '/workreport',
        name: 'WorkReport',
        component: () => import(/* webpackChunkName: "workreport" */ '@/views/WorkReport.vue'),
    },
    {
        path: '/sale',
        name: 'Sale',
        component: () => import(/* webpackChunkName: "sale" */ '@/views/Sale.vue'),
    },
    {
        path: '/salefilling',
        name: 'SaleFilling',
        component: () => import(/* webpackChunkName: "salefilling" */ '@/views/SaleFilling.vue'),
    },
    {
        path: '/replenishment',
        name: 'Replenishment',
        component: () => import(/* webpackChunkName: "replenishment" */ '@/views/Replenishment.vue'),
    },
    {
        path: '/ordercheck/:id',
        name: 'OrderCheck',
        component: () => import(/* webpackChunkName: "ordercheck" */ '@/views/OrderCheck.vue'),
    },
    {
        path: '/orderfind',
        name: 'OrderFind',
        component: () => import(/* webpackChunkName: "orderfind" */ '@/views/OrderFind.vue'),
    },
    {
        path: '/addTargetSale',
        name: 'AddTargetSale',
        component: () => import(/* webpackChunkName: "addtargetsale" */ '@/views/AddTargetSale.vue'),
    },
    {
        path: '/replenishmentbh',
        name: 'Replenishmentbh',
        component: () => import(/* webpackChunkName: "replenishmentbh" */ '@/views/ReplenishmentBH.vue'),
    },
    {
        path: '/replenishmentcheck/:id',
        name: 'Replenishmentcheck',
        component: () => import(/* webpackChunkName: "replenishmentcheck" */ '@/views/ReplenishmentCheck.vue'),
    },
    {
        path: '/replenishmentfind',
        name: 'ReplenishmentFind',
        component: () => import(/* webpackChunkName: "replenishmentfind" */ '@/views/ReplenishmentFind.vue'),
    },
    {
        path: '/orderbuilder',
        name: 'OrderBuilder',
        component: () => import(/* webpackChunkName: "orderbuilder" */ '@/views/OrderBuilder.vue'),
    },
    {
        path: '/saleurl/:uri',
        name: 'SaleUri',
        component: () => import(/* webpackChunkName: "saleurl" */ '@/views/SaleUri.vue'),
    },
    {
        path: '/displayFind',
        name: 'DisPlayFind',
        component: () => import(/* webpackChunkName: "test" */ '@/views/DisPlayFind.vue'),
    },
    {
        path: '/departDisplay/:id',
        name: 'DepartDisplay',
        component: () => import(/* webpackChunkName: "test" */ '@/views/DepartDisplay.vue'),
    },
    {
        path: '/lysfiltergoods/:id',
        name: 'LysFilterGoods',
        component: () => import(/* webpackChunkName: "lysfiltergoods" */ '@/views/LysFilterGoods.vue'),
    },
    {
        path: '/lysfiltergoods2/:id',
        name: 'LysFilterGoods2',
        component: () => import(/* webpackChunkName: "lysfiltergoods2" */ '@/views/LysFilterGoods2.vue'),
    },
    {
        path: '/lysfind',
        name: 'LysFind',
        component: () => import(/* webpackChunkName: "lysfind" */ '@/views/LysFind2.vue'),
    },
    {
        path: '/joint/:id',
        name: 'Joint',
        component: () => import(/* webpackChunkName: "joint" */ '@/views/Joint.vue'),
    },
    {
        path: '/joint2/:id',
        name: 'Joint2',
        component: () => import(/* webpackChunkName: "joint2" */ '@/views/Joint2.vue'),
    },
    {
        path: '/jointreport',
        name: 'JointReport',
        component: () => import(/* webpackChunkName: "jointreport" */ '@/views/JointReport.vue'),
    },

    {
        path: '/test',
        name: 'Test3',
        component: () => import(/* webpackChunkName: "lysfind" */ '@/views/Test3.vue'),
    },
];

export default routes;